import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";

import PagesTemplate from "./_template";

export const query = graphql`
  {
    site {
      siteMetadata {
        siteTitle
        loginLink
        signupLink
      }
    }
  }
`;

export default class Contact extends React.Component {
  render() {
    return (
      <PagesTemplate>
        <div>
          <Helmet
            title={`Contact Us at O3 | ${this.props.data.site.siteMetadata.siteTitle}`}
            meta={[
              {
                name: "description",
                content:
                  "Contact SMSReviews by O3 for any inquiries, questions, or requests.",
              },
              {
                name: "keywords",
                content:
                  "O3, Blue Star Services, business analytics, customer satisfaction, customer experience, text message surveys, digital health, patient satisfaction, outcome measures",
              },
            ]}
          />

          <div className="mw8 center pa3 cf">
            <div className="fl w-60-ns pr4-ns">
              <div>
                <h2>Let&apos;s Get In Touch</h2>
              </div>

              <p>
                The best relationships start with a little bit of human contact.
                We&apos;d love to speak with you about your needs and answer any
                questions you may have regarding O3&apos;s offerings.
              </p>
              <p>
                Don&apos;t hesitate to reach out via the form below or directly
                via email or social media.
              </p>

              <iframe
                height="557"
                allowTransparency="true"
                frameBorder="0"
                scrolling="no"
                className="w100 bn"
                title="Contact form"
                src="https://sparkgenius.wufoo.com/embed/segvwa40zglfh2/"
              >
                <a href="https://sparkgenius.wufoo.com/forms/segvwa40zglfh2/">
                  You can click here to complete our contact form.
                </a>
              </iframe>
            </div>

            <div className="fl w-30-ns ph3-ns">
              <h3 className="ttu">Direct Support</h3>

              <p className="black-50">Contact us via our various channels:</p>
              <ul className="list">
                <li>
                  <i className="fa fa-envelope mr2" />{" "}
                  <a href="mailto:info@o3powered.com">info@o3powered.com</a>
                </li>
                <li>
                  <i className="fa fa-twitter mr2" />{" "}
                  <a href="https://twitter.com/O3Powered">@O3Powered</a>
                </li>
                <li>
                  <i className="fa fa-phone-square mr2" />{" "}
                  <a href="tel:7279995205">727-999-5205</a>
                </li>
              </ul>

              <h3 className="ttu">Press Inquiries</h3>

              <p className="black-50">
                Members of the press can contact us directly here:
              </p>
              <ul className="list">
                <li>
                  <i className="fa fa-newspaper-o mr2" />{" "}
                  <a href="mailto:press@o3powered.com">press@o3powered.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </PagesTemplate>
    );
  }
}
